<template>
  <div :class="theme ? 'theme-background-bg' : ''">
    <div class="footer">
      <div class="footer-content">
        <div class="foot info">
          <!-- <ul>
          <li @click="underDevelop">关于我们</li>
          <li @click="underDevelop2">购物指南</li>
          <li @click="underDevelop3">支付方式</li>
          <li @click="underDevelop4">关注我们</li>
        </ul> -->
          <p>
            <a href="javascript:;">经营许可证编号：京ICP证150324号</a>&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备14005380号-1</a>&nbsp;&nbsp;&nbsp;&nbsp;
            <!-- <a href="http://www.crtvup.com.cn/img/hlwcbxkz.png" target="_blank">互联网出版许可证</a> -->
            <span>电话：010-68182532</span>
            
          </p>
          <p>
            <span>地址：北京市海淀区西四环中路45号</span>&nbsp;&nbsp;&nbsp;&nbsp;
            <span>邮箱：ysy_crtvup@163.com</span> &nbsp;&nbsp;&nbsp;&nbsp;
            <span>邮编：100039</span>
          </p>
          <p>
            <img src="@/assets/icon/police.png" alt="" />
            <span> 京公网安备11010802029563号</span>
            Copyright © 2023国家开放大学出版社有限公司版权所有
          </p>
        </div>
<!--        <div class="foot logo">-->
<!--          <img src="@/assets/icon/header-logoB.png" alt="" />-->
<!--          <span>开放云书院</span>-->
<!--        </div>-->
        <div class="foot codes">
          <div class="idCode">
            <img src="@/assets/images/idCode1.png" alt="" />
            <span>扫描二维码下载客户端</span>
          </div>
          <div class="idCode">
            <img src="@/assets/images/idCode2.png" alt="" />
            <span>扫描二维码关注我们</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { TofootNav } from "@/api/index/index";
import { getConfigKey } from "@/api/index/index.js";
export default {
  data() {
    return {
      type: null,
      theme:false
    };
  },
  created() {
    this.getConfig();
  },
  methods: {
    //首页置灰
    getConfig() {
      getConfigKey().then((res) => {
        this.UpTheme(res.data);
      });
    },
    UpTheme(data) {
      if (data == 0) {
        this.theme = true;
      } else {
        this.theme = false;
      }
    },
    getNav(type) {
      TofootNav(type).then((res) => {
        console.log(res.data);
      });
    },
    underDevelop() {
      this.type = "aboutUs";
      this.$alert("此功能正在开发中，敬请期待", "提示信息");
      // this.getNav(this.type);
    },
    underDevelop2() {
      this.type = "shopping";
      this.$alert("此功能正在开发中，敬请期待", "提示信息");
      // this.getNav(this.type);
    },
    underDevelop3() {
      this.type = "modePay";
      this.$alert("此功能正在开发中，敬请期待", "提示信息");
      // this.getNav(this.type);
    },
    underDevelop4() {
      this.type = "followUs";
      this.$alert("此功能正在开发中，敬请期待", "提示信息");
      // this.getNav(this.type);
    },
  },
};
</script>
<style scoped lang='scss'>
.footer {
  width: 100%;
  height: 248px;
  min-width: 1400px;
  background: #5d5d5d;
  display: flex;
  align-items: center;
  .footer-content {
    min-width: 1400px;
    display: flex;
    align-items: center;
     justify-content: space-between;
    margin: 0 auto;
    //padding-left: 81px;
    .foor {
      flex: 30%;
    }
    .info {
      margin-right: 81px;
      ul {
        height: 15px;
        margin-bottom: 44px;
        li {
          float: left;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #fbfbfb;
          margin-right: 70px;
          cursor: pointer;
        }
        li:last-child {
          margin: 0;
        }
      }
      p {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #fbfbfb;
        margin-bottom: 18px;
        a {
          color: #fbfbfb;
          text-decoration: none;
        }
      }
      p:last-of-type {
        margin: 0;
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: 16px;
          margin-right: 7px;
        }
        span {
          margin-right: 30px;
        }
      }
    }
    .logo {
      display: flex;
      align-items: center;
      margin-right: 80px;
      img {
        width: 70px;
        height: 54px;
        margin-right: 37px;
      }
      span {
        font-size: 24px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #ffffff;
      }
    }
    .codes {
      display: flex;
      .idCode {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 40px;
        img {
          width: 100px;
          height: 100px;
        }
        span {
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #fbfbfb;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
